export default "__VITE_ASSET__DbRDlpbX__"